import { fromJS } from 'immutable';
import * as menuprofileActions from '../actions/menuprofile';
import { SUCCESS, START, ERROR } from '../actions/global';
import { fetchingState, defaultPageSize } from '@constants';

const initialStats = {
  searchOptions: {},
  menuprofileList: {
    pageSize: defaultPageSize,
    sortModel: [],
    currentPage: 0,
    loadingAction: '',
  },
  menuprofile: {},
};

export default (state = fromJS(initialStats), action) => {
  let newState;
  let newMenuprofiles;
  let newMenuDefaults;
  switch (action.type) {
    case menuprofileActions.MENUPROFILE_LIST_FETCH[START]:
      return state.setIn(['menuprofileList', 'state'], fetchingState.FETCHING);
    case menuprofileActions.MENUPROFILE_LIST_FETCH[SUCCESS]:
      newState = state.setIn(
        ['menuprofileList', 'state'],
        fetchingState.LOADED,
      );
      newState = newState.setIn(
        ['menuprofileList', 'totalCount'],
        action.data && action.data.results ? action.data.results.length : 0,
      );
      return newState.setIn(
        ['menuprofileList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case menuprofileActions.MENUPROFILE_LIST_FETCH[ERROR]:
      return state.setIn(['menuprofileList', 'state'], fetchingState.ERROR);

    case menuprofileActions.MENUPROFILE_CHANGE_CURRENT_PAGE:
      return state.setIn(['menuprofileList', 'currentPage'], action.data);
    case menuprofileActions.MENUPROFILE_CHANGE_PAGE_SIZE:
      return state.setIn(['menuprofileList', 'pageSize'], action.data);
    case menuprofileActions.MENUPROFILE_CHANGE_SORT_MODEL:
      return state.setIn(['menuprofileList', 'sortModel'], fromJS(action.data));

    case menuprofileActions.MENUPROFILE_FETCH_START:
      return state.setIn(['menuprofile', 'state'], fetchingState.FETCHING);
    case menuprofileActions.MENUPROFILE_FETCH_SUCCESS:
      newState = state.setIn(['menuprofile', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['menuprofile', 'data'],
        fromJS(action.data ? action.data.results[0] : null),
      );
    case menuprofileActions.MENUPROFILE_FETCH_ERROR:
      return state.setIn(['menuprofile', 'state'], fetchingState.ERROR);

    case menuprofileActions.MENUPROFILE_UPDATE_START:
      return state.setIn(['menuprofile', 'state'], fetchingState.SAVING);
    case menuprofileActions.MENUPROFILE_UPDATE_ERROR:
      return state.setIn(['menuprofile', 'state'], fetchingState.ERROR);
    case menuprofileActions.MENUPROFILE_UPDATE_SUCCESS:
      newState = state.setIn(['menuprofile', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['menuprofile', 'data'],
        fromJS(action.data.results[0]),
      );
    case menuprofileActions.MENUPROFILE_RESET_DATA:
      return state.setIn(['menuprofile'], fromJS({}));

    case menuprofileActions.MENUPROFILE_CREATE[START]:
      return state.setIn(['menuprofile', 'state'], fetchingState.SAVING);
    case menuprofileActions.MENUPROFILE_CREATE[SUCCESS]:
      newState = state.setIn(['menuprofile', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['menuprofile', 'data'],
        fromJS(action.data.results[0]),
      );
    case menuprofileActions.MENUPROFILE_CREATE[ERROR]:
      return state.setIn(['menuprofile', 'state'], fetchingState.ERROR);

    case menuprofileActions.MENUPROFILE_DUPLICATE[START]:
      return state.setIn(['menuprofileList', 'loadingAction'], 'duplicate');
    case menuprofileActions.MENUPROFILE_DUPLICATE[ERROR]:
      return state.setIn(['menuprofileList', 'loadingAction'], '');
    case menuprofileActions.MENUPROFILE_DUPLICATE[SUCCESS]:
      newMenuprofiles = state.getIn(['menuprofileList', 'data']).toJS();
      newMenuprofiles = [action.data.results[0], ...newMenuprofiles];
      newState = state.setIn(['menuprofileList', 'loadingAction'], '');
      return newState.setIn(
        ['menuprofileList', 'data'],
        fromJS(newMenuprofiles),
      );

    case menuprofileActions.MENUPROFILE_DELETE[SUCCESS]:
      newMenuprofiles = state.getIn(['menuprofileList', 'data']).toJS();
      newMenuprofiles = newMenuprofiles.filter(
        n => n.menuID !== action.menuprofileId,
      );
      return state.setIn(['menuprofileList', 'data'], fromJS(newMenuprofiles));

    // MENU DEFAULTS

    case menuprofileActions.MENU_DEFAULT_LIST_FETCH[START]:
      return state.setIn(['menuDefaultList', 'state'], fetchingState.FETCHING);
    case menuprofileActions.MENU_DEFAULT_LIST_FETCH[SUCCESS]:
      newState = state.setIn(
        ['menuDefaultList', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['menuDefaultList', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case menuprofileActions.MENU_DEFAULT_LIST_FETCH[ERROR]:
      return state.setIn(['menuDefaultList', 'state'], fetchingState.ERROR);

    case menuprofileActions.MENU_DEFAULT_FETCH[START]:
      return state.setIn(['menuDefault', 'state'], fetchingState.FETCHING);
    case menuprofileActions.MENU_DEFAULT_FETCH[SUCCESS]:
      newState = state.setIn(['menuDefault', 'state'], fetchingState.LOADED);
      return newState.setIn(
        ['menuDefault', 'data'],
        fromJS(action.data ? action.data.results[0] : {}),
      );
    case menuprofileActions.MENU_DEFAULT_FETCH[ERROR]:
      return state.setIn(['menuDefault', 'state'], fetchingState.ERROR);

    case menuprofileActions.MENU_DEFAULT_CREATE[START]:
      return state.setIn(['menuDefaultList', 'state'], fetchingState.SAVING);
    case menuprofileActions.MENU_DEFAULT_CREATE[SUCCESS]:
      newMenuDefaults = state.getIn(['menuDefaultList', 'data']).toJS();
      newMenuDefaults = [action.data.results[0], ...newMenuDefaults];
      newState = state.setIn(
        ['menuDefaultList', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['menuDefaultList', 'data'],
        fromJS(newMenuDefaults),
      );
    case menuprofileActions.MENU_DEFAULT_CREATE[ERROR]:
      return state.setIn(['menuDefaultList', 'state'], fetchingState.ERROR);

    case menuprofileActions.MENU_DEFAULT_UPDATE[START]:
      return state.setIn(['menuDefaultList', 'state'], fetchingState.FETCHING);
    case menuprofileActions.MENU_DEFAULT_UPDATE[SUCCESS]:
      newMenuDefaults = state.getIn(['menuDefaultList', 'data']).toJS();
      newMenuDefaults = newMenuDefaults.filter(
        item => item.menuDefaultID !== Number(action.menuDefaultId),
      );
      newMenuDefaults = [action.data.results[0], ...newMenuDefaults];
      newState = state.setIn(
        ['menuDefaultList', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['menuDefaultList', 'data'],
        fromJS(newMenuDefaults),
      );

    case menuprofileActions.MENU_DEFAULT_DELETE[SUCCESS]:
      newMenuDefaults = state.getIn(['menuDefaultList', 'data']).toJS();
      newMenuDefaults = newMenuDefaults.filter(
        n => n.menuDefaultID !== action.menuDefaultId,
      );
      return state.setIn(['menuDefaultList', 'data'], fromJS(newMenuDefaults));

    case menuprofileActions.MENU_PROFILES_AUTHORIZED_FETCH[START]:
      return state.setIn(
        ['menuprofilesAuthorized', 'state'],
        fetchingState.FETCHING,
      );
    case menuprofileActions.MENU_PROFILES_AUTHORIZED_FETCH[SUCCESS]:
      newState = state.setIn(
        ['menuprofilesAuthorized', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['menuprofilesAuthorized', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case menuprofileActions.MENU_PROFILES_AUTHORIZED_FETCH[ERROR]:
      return state.setIn(
        ['menuprofilesAuthorized', 'state'],
        fetchingState.ERROR,
      );

    case menuprofileActions.PROPERTY_TYPES_AVAIL_FETCH[START]:
      return state.setIn(
        ['propertyTypesAvailable', 'state'],
        fetchingState.FETCHING,
      );
    case menuprofileActions.PROPERTY_TYPES_AVAIL_FETCH[SUCCESS]:
      newState = state.setIn(
        ['propertyTypesAvailable', 'state'],
        fetchingState.LOADED,
      );
      return newState.setIn(
        ['propertyTypesAvailable', 'data'],
        fromJS(action.data ? action.data.results : []),
      );
    case menuprofileActions.PROPERTY_TYPES_AVAIL_FETCH[ERROR]:
      return state.setIn(
        ['propertyTypesAvailable', 'state'],
        fetchingState.ERROR,
      );

    default:
      return state;
  }
};
